import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ivr_template",
  "use": "ivr_template-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"ivr_template\">\r\n<path class=\"st0\" d=\"M36,26h-3v-7H21v-5h3c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2h-8c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h3v5H7v7H4\r\n\tc-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2v-6c0-1.1-0.9-2-2-2H9v-5h22v5h-3c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h8\r\n\tc1.1,0,2-0.9,2-2v-6C38,26.9,37.1,26,36,26z M16,6h8v6h-8V6z M12,28v6H4v-6H12z M36,34h-8v-6h8V34z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol